<template>
  <CooperationCases id="cases" class="cooperation-cases-page" />
</template>

<script setup>
import { inject, onMounted, onUnmounted } from "vue";
import CooperationCases from '../components/CooperationCases.vue';
// 组件挂载时将navbar文字颜色改为黑色
const changeNavbarTextColor = inject("changeNavbarTextColor");
onMounted(() => {
  if (changeNavbarTextColor) {
    changeNavbarTextColor("#000000", "#000000"); // 改为黑色
  }
});

// 组件卸载时恢复navbar文字颜色为白色
onUnmounted(() => {
  if (changeNavbarTextColor) {
    changeNavbarTextColor("white", "white"); // 恢复白色
  }
});
</script>

<style>
.cooperation-cases-page {
  padding-top: 100px !important;
}
</style>